import React from "react";
import styles from "./styles.module.scss";
import TagsList from "./TagsList/TagsList";
import TagsFilter from "./TagsFilter";
import { shallowEqual, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { RootState } from "typedefs";
import PagePanel from "app/components/PagePanel";
import AccountWrap from "../Account";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import {
  TagSortOrder,
  buildSortOrderSearch,
  parseSortOrder,
} from "./Tags.types";

const Tags = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const user = useSelector((state: RootState) => state.user.data, shallowEqual);
  const tags = useSelector((state: RootState) => state.tag.data, shallowEqual);
  const canAddTag = user?.planPermissions?.includes("create_tags") ?? false;

  // The order lives in the URL so it survives leaving the page to add, rename or
  // delete a tag, rather than resetting to A to Z on the way back.
  const sortOrder = parseSortOrder(search);

  const setSortOrder = (order: TagSortOrder) => {
    // Replace rather than push, so toggling the order does not fill the back
    // history with a step for every choice.
    history.replace({ pathname, search: buildSortOrderSearch(search, order) });
  };

  const isUserLoaded = Boolean(user);

  const canSort = Boolean(tags && tags.length > 1);

  return (
    <AccountWrap>
      <div className={styles.container}>
        <PagePanel
          title={t("Tags")}
          titleStyles={styles.title}
          className={styles.panel_container}
          headerChildren={
            <div className={styles.header_controls}>
              {isUserLoaded &&
                (canAddTag ? (
                  <Link
                    to={`/account/tags/new${search}`}
                    className={cls("btn btn-primary", styles.add_button)}
                  >
                    {t("+ Add Tag")}
                  </Link>
                ) : (
                  <button
                    type="button"
                    disabled
                    className={cls("btn btn-primary", styles.add_button)}
                  >
                    {t("+ Add Tag")}
                  </button>
                ))}
            </div>
          }
        />
        {canSort && (
          <div className={styles.filter_row}>
            <hr />
            <TagsFilter value={sortOrder} onChange={setSortOrder} />
          </div>
        )}
        <TagsList sortOrder={sortOrder} />
      </div>
    </AccountWrap>
  );
};

export default Tags;
